import React from 'react';
import {
  Datagrid,
  DateField,
  NumberField,
  List,
  ReferenceField,
  TextField,
  useTranslate,
} from 'react-admin';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const OpportunityDetailList = (props) => {
  const translate = useTranslate();
  useDocumentTitle(
    translate('app.page_title.list', {
      resource: translate('resources.opportunity_detail.name', {
        smart_count: 2,
      }),
    }),
  );
  return (
    <List
      {...props}
      bulkActionButtons={false}
      perPage={25}
      sort={{ field: 'date', order: 'DESC' }}
    >
      <Datagrid>
        <DateField source="date" textAlign="center" />
        <ReferenceField
          source="account_id"
          reference="account"
          textAlign="center"
          link="show"
        >
          <TextField source="name" />
        </ReferenceField>
        <TextField source="recap" label="Récapitulatif" emptyText="∅" />
        <TextField source="stagename" label="Stage Name" emptyText="∅" />
        <NumberField source="amount" emptyText="∅" textAlign="center" />
      </Datagrid>
    </List>
  );
};

export default OpportunityDetailList;
